<template>
    <div class="content-wrapper">
        <div class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <h1>
                            My Business
                        </h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="content">

            <!-- Button trigger modal -->

            <!-- Modal -->
            <div class="modal fade" id="busInfo" tabindex="-1" role="dialog" aria-labelledby="busInfo" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="busInfoTitle">Business Information</h5>
                        </div>
                        <div class="modal-body">
                            Well done! You have sucessfully added your business information
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal" @click='gotoDashboard'>Dashboard</button>
                            <button type="button" class="btn btn-primary"  data-dismiss="modal" @click='gotoLoanApp'>Apply a Loan</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-show="!addBusiness">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <p>For us to easily help you with your loan application, please tell us about your business/businesses. Just click Add my Business below</p>
                            <button class="btn btn-success" @click='showBusiness'><i class="fas fa-plus"></i>&nbsp;Add My Business Here</button>
                        </div>
                    </div>

                </div>
            </div>
            <div class="row" v-show='addBusiness'>
                <div class="col-md-2"></div>
                <div class="col-md-8">
                    <div class="card">
                        <div class="card-body" v-show="prevStep">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Tell us more about your business</label>
                                        <input autocomplete="off" type="text" class="form-control" placeholder="Business Name">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <input autocomplete="off" type="text" class="form-control" placeholder="Total Years in Business">
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="card-body" v-show="nextStep">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Province</label><span class="danger fs-18 bold">&nbsp;*</span>
                                        <select class="form-control custom-select text-uppercase">
                                            <option value="" selected disabled>Select Province</option>
                                            <!-- <option v-for="data in data_provinces" :key="data.province_code" :value="data.province_code">{{data.province}}</option> -->
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>City/Municipality</label><span class="danger fs-18 bold">&nbsp;*</span>
                                        <select class="form-control custom-select text-uppercase">
                                            <option value="" selected disabled>Select City</option>
                                            <!-- <option v-for="data in filteredCity3" :key="data.city_code" :value="data.city_code">{{data.city}}</option> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Barangay</label><span class="danger fs-18 bold">&nbsp;*</span>

                                        <select class="form-control custom-select text-uppercase">
                                            <option value="" selected disabled>Select Barangay</option>
                                            <!-- <option v-for="data in data_barangay1" :key="data.bcode" :value="data.bcode">{{data.bname}}</option> -->
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">

                                <div class="col-sm-4">
                                    <div class="form-group">

                                        <label>House No/Block & Lot/Building</label><span class="danger fs-18 bold">&nbsp;*</span>
                                        <input autocomplete="off" type="text" class="form-control text-uppercase">

                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">

                                        <label>Street Name / Subdivision</label><span class="danger fs-18 bold">&nbsp;*</span>
                                        <input autocomplete="off" type="text" class="form-control text-uppercase">

                                    </div>
                                </div>



                            </div>
                        </div>
                        <k-progress :percent="percent" :color="getColor"></k-progress>
                        <div class="card-footer">
                            <button @click="decreasePercentage" class="btn btn-success">Back</button>
                            <button @click="increasePercentage" class="btn btn-success float-right">Next</button>

                        </div>
                    </div>

                </div>
                <div class="col-md-2"></div>

            </div>

        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                percent: 50,
                ifUp: true,

                addBusiness: false,
                nextStep: false,
                prevStep: true,
            }
        },

        methods: {

            showBusiness() {
                this.addBusiness = true
            },

            nextSteps() {
                this.nextStep = true;
                this.prevStep = false;
            },

            prevSteps() {
                this.nextStep = false;
                this.prevStep = true;
            },


            increasePercentage() {
                if (this.percent <= 50) {
                    this.percent += 50;
                    this.nextSteps();
                }
                if (this.percent == 100) {
                    $('#busInfo').modal('show')
                }
            },

            gotoDashboard() {
                this.$router.push('/dashboard');
                this.addBusiness = false;
                this.percent = 50;
                this.nextStep = false;
                this.prevStep = true;
            },

            gotoLoanApp() {
                this.$router.push('/dashboard');
                this.addBusiness = false;
                this.percent =50;
                this.nextStep = false;
                this.prevStep = true;
            },
            decreasePercentage() {
                if (this.percent >= 50) {
                    this.percent -= 50;
                    this.prevSteps();
                }
                if (this.percent < 50) {
                    this.addBusiness = false;
                    this.percent = 50;
                    this.nextStep = false;
                    this.prevStep = true;
                }

            },


            getColor(percent) {
                if (percent < 40) {
                    return '#ffc069';
                } else if (percent < 60) {
                    return '#fadb14';
                } else if (percent < 80) {
                    return '#13c2c2';
                } else {
                    return '#389e0d';
                }
            }
        },
    }
</script>